import { css, StyleSheet } from 'aphrodite';
import { DonationFrequency, IDonationSurveyResponse } from '../../models/Api';
import { formatCentsAsDollars } from '../../models/currency';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

const styles = StyleSheet.create({
	sectionTitle: {
		margin: `0 0 ${spacing.md}px`,
		fontSize: typography.fontSizes.xs,
		textTransform: 'uppercase',
		letterSpacing: 1,
		color: colors.text.light,
	},
	totalAmount: {
		fontSize: 32,
		fontWeight: 700,
		margin: `0 0 ${spacing.md}px`,
	},
	lineItemsContainer: {
		borderBottom: `1px solid ${colors.border.light}`,
		paddingBottom: spacing.sm,
		marginBottom: spacing.sm,
	},
	lineItem: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: typography.fontSizes.sm,
		padding: `${spacing.xs}px 0`,
	},
	totalRow: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
});

const getDonationFrequencyLabel = (frequency?: DonationFrequency | null): string => {
	switch (frequency) {
		case DonationFrequency.Monthly:
			return 'Monthly donation';
		case DonationFrequency.Yearly:
			return 'Yearly donation';
		default:
			return 'One-time donation';
	}
};

export const DonationOrderSummary = ({ donationResponse }: { donationResponse: IDonationSurveyResponse }) => {
	const totalAmount = donationResponse.donorCoversFees
		? donationResponse.donationAmount + donationResponse.serviceFee
		: donationResponse.donationAmount;

	return (
		<>
			<h3 className={css(styles.sectionTitle)}>Your Donation</h3>
			<p className={css(styles.totalAmount)}>${formatCentsAsDollars(totalAmount)}</p>
			<div className={css(styles.lineItemsContainer)}>
				<div className={css(styles.lineItem)}>
					<span>{getDonationFrequencyLabel(donationResponse.donationFrequency)}</span>
					<span>${formatCentsAsDollars(donationResponse.donationAmount)}</span>
				</div>
				{donationResponse.donorCoversFees && (
					<div className={css(styles.lineItem)}>
						<span>Service fee</span>
						<span>${formatCentsAsDollars(donationResponse.serviceFee)}</span>
					</div>
				)}
			</div>
			<div className={css(styles.totalRow)}>
				<span>Total</span>
				<span>${formatCentsAsDollars(totalAmount)}</span>
			</div>
		</>
	);
};
